import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    root: {
        flex: 1,
    },
    rootNoChannels: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    noChannelsText: {
        lineHeight: 24,
    },
});

export default styles;
